<script lang="ts" setup>
import type { Ap006ImageSlide } from "~/constant";

const props = defineProps<{
  images: Ap006ImageSlide[];
}>();

const { activeIndex } = useAutoFadeImages(props.images.length);
</script>

<template>
  <NuxtImg
    v-for="(slide, index) in props.images"
    :key="slide.src"
    class="fade-image"
    decoding="async"
    :src="slide.src"
    :alt="slide.alt"
    :class="[slide.position, { 'is-active': activeIndex === index }]"
    :loading="index === 0 ? 'eager' : 'lazy'"
    :fetchpriority="index === 0 ? 'high' : 'auto'"
    :preload="index === 0 ? { fetchPriority: 'high' } : undefined"
  />
</template>

<style scoped>
@reference "~/assets/css/main.css";

.fade-image {
  @apply absolute inset-0 size-full object-cover opacity-0 transition-opacity duration-800 ease-in-out;
}

.fade-image.is-active {
  @apply opacity-100;
}
</style>
